import React from "react";
import { Carousel } from "react-responsive-carousel";
import { BgVideo, videoSize } from "../../helpers";

const MainHeader = ({ title, links }) => {
  return (
    <div>
      <section
        data-background="assets/imagenes/img-header.jpg"
        data-background-video="assets/videos/bg-lic.mp4"
        className="section section-jumbotron contain-cover contain-cover-video"
      >
        <div className="video-container">
          <video
            autoPlay="autoplay"
            loop="loop"
            muted={true}
            poster="assets/imagenes/img-header.jpg"
          >
            <source src="assets/videos/bg-lic.mp4" />
          </video>
        </div>
      </section>
      <div
        className="text-center"
        style={{
          transform: `scale(${window.innerWidth >= 768 ? "0.8" : "0.6"})`,
          marginTop: "-10px",
        }}
      >
        {/* <a href="#material-estudio" id="btn_bajada"><img src="assets/imagenes/header-down.png" alt="material de estudio"></img></a> */}
      </div>
    </div>
  );
};

export default MainHeader;
/*
    <div style={{
        height:"80vh",
        overflow:"hidden",
    }}>
        {
            console.log(window.onresize)
        }
        <Carousel
            showStatus={false}
            showIndicators={false}
            showArrows={false}
            showThumbs={false}
            dynamicHeight={true}
        >
            <video autoPlay="autoPlay" loop="loop" muted  style={{
                //position: "fixed",
               // left:"0",
                marginTop:"-100px",
                width: "100%",
                //height: videoSize,
                //objectFit:"cover",
                //filter:"brightness(40%)",
            }}>

                <source src="assets/videos/bg-lic.mp4"/>
            </video>
        </Carousel>
    </div>























<div style={{
    height:"50vh",
    overflow:"hidden",
}}>
    {
        console.log(window.onresize)
    }
    <Carousel
        showStatus={false}
        showIndicators={false}
        showArrows={false}
        showThumbs={false}
        dynamicHeight={true}
    >
        <video autoPlay="autoPlay" loop="loop" muted  style={{
        position: "absolute",
        left:"0",
        top:"0",
        width: "100%",
        height: videoSize,
        objectFit:"cover",
        filter:"brightness(40%)",
        zIndex: 0,
    }}>

        <source src="assets/videos/bg-lic.mp4"/>
    </video>
    </Carousel>
</div>

<div><div className="pt-5" style={{
    backgroundImage: `url(${"assets/imagenes/img-header.jpg"})`,
    height: window.innerHeight <= 640 ? "68vh" : "60vh",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    backgroundBlendMode: "multiply",
    overflow:"hidden"
}}>
    <video autoPlay="autoPlay" loop="loop" muted  style={{
        position: "absolute",
        left:"0",
        top:"0",
        width: "100%",
        height: videoSize,
        objectFit:"cover",
        filter:"brightness(40%)",
        zIndex: 0,
    }}>

        <source src="assets/videos/bg-lic.mp4"/>
    </video>
    <h1 className="text-white text-center mt-5" style={{
        paddingTop: window.innerWidth >= 768 ? "15vh": "3vh",
        transform: `scale(${ window.innerWidth >= 768 ? "1"  : "0.8"})`
    }}>{title || "Mejores conductores, mejores ciudadanos"}</h1>

    <div className={`text-center`} style={{
        paddingTop: window.innerWidth >= 768 ? "6vh": "2vh",
        transform: `scale(${ window.innerWidth >= 768 ? "0.8"  : "0.6"})`
    }}>
        {!!links && links.map( ({redirect, iconPath, alt}, i) => <a className="m-1"
                                                                    href={redirect} target="_blank">
            <img src={iconPath} alt={alt}/>
        </a>)}
    </div>
</div>
    <div className="text-center" style={{
        transform: `scale(${ window.innerWidth >= 768 ? "0.8"  : "0.6"})`,
        marginTop: "-25px"
    }}>
        <a href="#material-estudio" id="btn_bajada">
            <img src="assets/imagenes/header-down.png" alt="material de estudio"/>
        </a>
    </div>
</div>



 */
